export default __webpack_public_path__ + "static/media/014-backpack.c39c9460.svg";